import { mapGetters } from "vuex";

export const authComputed = {
  ...mapGetters([
    "loggedIn",
    "hasPhoneNumber",
    "getUser",
    "getToken",
    "getAuthAction"
  ])
};
